import script from "./SearchBarV2.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchBarV2.vue?vue&type=script&setup=true&lang=js"

import "./SearchBarV2.vue?vue&type=style&index=0&id=21ef30fa&scoped=true&lang=css"

import exportComponent from "/home/runner/work/tests-frontend/tests-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21ef30fa"]])

export default __exports__